export default "__VITE_ASSET__DmveB9JO__"